module.exports = __webpack_public_path__ + "img/framenew_box23.ea0b697a.jpg";